import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { NeptuneApi } from '../genericApi/neptune.api';
import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';

import { RSSFeedApi } from './models/rss-feed-api.model';
import { MultiBaseAbstractApi } from '../genericApi/multi-base-abstract.api';

interface FeedWrapperApi {
    feeds: RSSFeedApi[];
}

@Injectable()
export class RSSFeedApiService extends MultiBaseAbstractApi<RSSFeedApi, RSSFeedApi> {

    constructor(private neptuneApi: NeptuneApi) {
        super();
    }

    getList(): Observable<RSSFeedApi[]> {
        return this.neptuneApi.api<FeedWrapperApi>(
            '/feeds',
            null,
            HttpVerbsEnum.GET
        ).pipe(
            map(feedWrapper => feedWrapper.feeds)
        );
    }

    create(feed: RSSFeedApi): Observable<number> {
        return this.neptuneApi.api<number>(
            '/feeds',
            feed,
            HttpVerbsEnum.POST
        );
    }


    update(feed: RSSFeedApi): Observable<null> {
        return this.neptuneApi.api<null>(
            `/feeds/${feed.id}`,
            feed,
            HttpVerbsEnum.PATCH
        );
    }


    deleteById(id: number): Observable<null> {
        return this.neptuneApi.api<null>(
            `/feeds/${id}`,
            null,
            HttpVerbsEnum.DELETE
        );
    }

    getById(id: number): Observable<RSSFeedApi> {
        throw new Error('Method not implemented.');
    }
}
